import { apiService } from "@/_services";
import { formatDate_YMD, timeParseNull2 } from "@/_core/_helpers/_helpers";

/**
 * Fetches historical co-integration data for a selection of assets.
 *
 * @param {object} _this - Context variables (typically Vue or React component state).
 * @param {array} commoditiesPKs - Array of commodity primary keys.
 * @param {array} currenciesPKs - Array of currency primary keys.
 * @param {array} indexesPKs - Array of index primary keys.
 * @returns {Promise<void>} - Resolves when data is fetched and stored in `_this.data.historical`.
 */
export function getCoIntegrationHistorical(
  _this,
  commoditiesPKs,
  currenciesPKs,
  indexesPKs
) {
  // Set loading state to indicate data fetching
  Object.assign(_this.loading, { historical: true });
  // Define API request parameters
  const params = {
    method: "GET",
    endpoint: "cointegration_historical",
    content_type: "application/json",
    query_params: {
      format: "json",
      commoditiesPKs: { pks: commoditiesPKs },
      currenciesPKs: { pks: currenciesPKs },
      indexesPKs: { pks: indexesPKs },
      initialDate: formatDate_YMD(_this.settings["initialDate"]) // Format the initial date
    }
  };
  // Fetch historical data from API
  return apiService
    .getAll(params)
    .then(data => {
      // Parse date strings into JavaScript Date objects
      data.forEach(d => {
        d.date = timeParseNull2(d.date);
      });
      // Store retrieved data in component state
      Object.assign(_this.data, { historical: data });
      // Mark loading as complete
      Object.assign(_this.loading, { historical: false });
    })
    .catch(error => {
      // Handle errors and reset loading state
      console.error("Error fetching historical data:", error);
      Object.assign(_this.loading, { historical: false });
    });
}
